export default __webpack_public_path__ + "static/media/photo-1569443693539-175ea9f007e8.da18bfdc.jpeg";